import * as React from 'react';

import {Link} from '../link/link';
import {Title} from '../typography/title';

import styles from './popover-list-header.module.css';

type Props = {
    title: string;
    viewAllLink: string;
};

export function PopoverListHeader(props: Props) {
    return (
        <div className={styles.header}>
            <Title>{props.title}</Title>
            <Link newTab={true} variant='primary' href={props.viewAllLink}>
                View all
            </Link>
        </div>
    );
}
